import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMessageScrollerFooterProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useMessageScrollerRootContext
} from "../../context";

const MessageScrollerFooter: FC<IMessageScrollerFooterProps> = ({
    customTheme,
    children,
    style,
    ...props
}) => {
    const rootContext = useMessageScrollerRootContext();

    const {
        shapeConfigs,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme ?? rootContext?.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        shapeConfigs,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default MessageScrollerFooter;
